/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import Grid from '../../../containers/dashboard/grid';
import Task from '../../../containers/task/working';
import {getTaskColumns, getTasksInProgress} from '../../../store/tasks/selectors';
import {getworkstepcount} from "../../../store/tasks/actions";

class WorkingGrid extends React.Component {
    componentDidMount() {

        const {getworkstepcount} = this.props;
        getworkstepcount()
    }

    render() {
        const {tasks, columns} = this.props;

        return (
            <Grid
                tasks={tasks}
                columns={columns}
                taskComponent={Task}
                allowedStatuses={[]}
            />
        );
    }
}

export default connect(
    state => ({
        tasks: getTasksInProgress(state),
        columns: getTaskColumns(state, getTasksInProgress),
    }), {getworkstepcount}
)(WorkingGrid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/working.js